module.exports = __webpack_public_path__ + "img/icon-my-profile.9147353d.svg";